import { useAppCookies } from '@!/Hooks'

export const useJumpLastUrl = () => {
  const { lastUrlCookie } = useAppCookies()
  const lastUrl = !lastUrlCookie ? '/' : lastUrlCookie
  const jumpLastUrl = () => (window.location.href = lastUrl)

  return jumpLastUrl
}
